import { Link } from "@tanstack/react-router";
import StoryDoodleLogo from "../../assets/StoryDoodleLogo.svg";
import { cn } from "../../lib/utils";

interface LogoProps {
    size?: "sm" | "md" | "lg" | "xl" | "xxl";
    className?: string;
    clickable?: boolean;
}

export function Logo({ size = "lg", className, clickable }: LogoProps) {
    const sizeClasses = {
        sm: "h-6",
        md: "h-8",
        lg: "h-12",
        xl: "h-16",
        xxl: "h-20",
    };

    const content = (
        <img
            src={StoryDoodleLogo}
            alt="StoryDoodle"
            className={cn(
                "object-contain",
                sizeClasses[size],
                clickable && "hover:opacity-80 transition-opacity",
                className
            )}
        />
    );

    if (clickable) {
        return (
            <Link to="/" className="inline-block">
                {content}
            </Link>
        );
    }

    return content;
}
